export enum DemoInvoiceSendChannel {
  Download = 'download',
  EInvoice = 'eInvoice',
  Email = 'email',
}
